import { HOSTNAME, IS_ANDROID } from 'src/constants';

function cleanUrl(url: string): string;
function cleanUrl(url?: string): undefined;
function cleanUrl(url?: string): string | undefined {
  return __DEV__ && IS_ANDROID && HOSTNAME ? url?.replace('localhost:', `${HOSTNAME}:`) : url;
}

export default cleanUrl;
